module.exports = __webpack_public_path__ + "img/icon2.e01b48b5.png";